import React from 'react'

export default function Footer() {
  return (
    <footer>          
    <a href='https://www.tallyglobal.co.tz/' target='_blank' rel='noreferrer'>www.<span>tallyglobal</span>.co.tz</a>
    {/* <ul className='contreinfo'>
      <li>India</li>
      <li>Tanzania</li>
      <li>u.a.e</li>
      <li>Angola</li>
      </ul> */}
    </footer>
  )
}
